import { render, staticRenderFns } from "./TownSquare2.vue?vue&type=template&id=0a61313d"
import script from "./TownSquare2.vue?vue&type=script&lang=js"
export * from "./TownSquare2.vue?vue&type=script&lang=js"
import style0 from "./TownSquare2.vue?vue&type=style&index=0&id=0a61313d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports